import React, { useEffect, useState } from 'react'
import { Form } from "react-router-dom";
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { IWorkSpaceModal } from '../../models/SharedModel';
import { folderNameRegex } from '../../helpers/RegexHelpers';
import Service from '../../services';
import SearchableDropdown from '../../commonfields/SearchableDropdown';
import { IDropdownOptionsModel } from '../../models/CommonFields';
import { text_convert_lower } from '../../helpers/GenericHelpers';
import userDark from '../../images/user-dark.png';

interface IWorkSpaceFormProps {
  cancelWorkSpaceMapping:Function;
  setSelectedOptions:Function
  selectedOptions:[];
  mapUserAndWorkSpace:Function;
  }

const WorkSpaceUserMappingForm = (props: IWorkSpaceFormProps) => {
    const {setSelectedOptions, selectedOptions, mapUserAndWorkSpace, cancelWorkSpaceMapping} = props;
    const service = new Service();
    const [userList, setUserList] = useState<any>([]);
    useEffect(()=>{
        setSelectedOptions([])
     service.get_list_of_users().then((response:any)=>{
       console.log(response.data)
       setUserList(response?.data?.list_of_users);
     }).catch((error:any)=>{
       console.log(error)
     })
    },[])

      const handleSelectChange = (event:any) => {
        const selected:any = Array.from(event.target.selectedOptions, (option:any) => option.value);
        setSelectedOptions(selected);
      };
  const handleUserChange = (values: IDropdownOptionsModel) => {
    setSelectedOptions(values);
  }

  const displayOptions = (values: any) => {
    const keys = Object.keys(values)
    return values?.map((each:any) => ({
      value: each?.user_id,
      label: text_convert_lower(each?.user_name),
    }))
  }
  return (
    <div className="project-form">
      <Form>
        <div className="input-row">
          <FormGroup className={`project-input type}`}>
          <div className='multi-select-users'>
              {selectedOptions?.length<=0 ? <Label for="eproject-type">Select Users<span className='required'>*</span></Label> :''  }
              {selectedOptions?.map((ele:any)=>
              <div className='user-details'>
                <img src={userDark} alt='user'/>
                <div className='text'>{ele?.label}</div>
              </div>)}
            </div>
            <SearchableDropdown
              // value={selectedData?.roles}
              handleChange={handleUserChange}
              options={displayOptions(userList)}
              classNamePrefix='extractedSearch'
              isMulti={true}
              placeholder='select roles'
            />
            {/* <Label for="eproject-type">Select Users<span className='required'>*</span></Label>
            <Input type="select" className='map-user-select' name="selectMulti" id="exampleSelectMulti" multiple onChange={handleSelectChange}>
              {userList.map((el:any,index:number)=>(
                  <option key={index} value={el.user_id}>{el.user_name}</option>
              ))}
            </Input> */}
          </FormGroup>
        </div>
        <div className="btns">
          <Button
            className="cancel"
            onClick={() => cancelWorkSpaceMapping()}
          >
            Cancel
          </Button>
          <Button
            className="submit"
            disabled={selectedOptions?.length<1}
            onClick={() => mapUserAndWorkSpace()}
          >
            Submit
          </Button>
        </div>
      </Form>
      </div>
  )
}

export default WorkSpaceUserMappingForm